import * as urls from "../../api/C4S Decommission - Replacement/url";
import { getRequest } from "../../../services/RestServices";

export const getAllReasonsData = async (category) => {
  try {
    return await getRequest(urls.REJECT_REASONS_DATA + `?category=${category}&application=${"C360"}`);
  } catch (err) {
    return err;
  }
};
